import { useEffect, useState, RefObject } from "react";

/**
 * Hook to detect if a text element is truncated (ellipsis)
 * @param ref - ref to the element to check
 * @param deps - optional dependencies to re-run the check
 * @returns isTruncated - boolean if the text is overflowing
 */
export const useIsTruncated = (ref: RefObject<HTMLElement>, deps: any[] = []) => {
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const checkTruncation = () => {
            const el = ref.current;
            if (el) {
                setIsTruncated(el.scrollWidth > el.clientWidth);
            }
        };

        checkTruncation();
        window.addEventListener("resize", checkTruncation);

        return () => {
            window.removeEventListener("resize", checkTruncation);
        };
    }, [ref, ...deps]);

    return isTruncated;
};
